import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useForm, SubmitHandler } from "react-hook-form";
import { AppDispatch, RootState } from "../../../core/data/redux/store";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import styles
import { loginUser, registerUser, resetAuth } from "../../../core/data/redux/action";
// import GoogleLoginComponent from "../../../feature-module/authentication/GoogleLoginComponent";
// import { Link } from "react-router-dom";
import Lottie from "lottie-react";
import Loader from "../../../core/data/img/car_loading.json";

const LoginModal = () => {

    const dispatch = useDispatch<AppDispatch>();
    const [isToggle, setIsToggle] = useState(false);

    type LoginFormValues = {
        email: string;
        password: string;
    };


    type RegisterFormValues = {
        first_name: string;
        last_name: string;
        email: string;
        password: string;
        password_confirmation: string;
        country_code: string;
        mobile: string;
        address: string;
        city: string;
        state: string;
        zip: string;
        terms_conditions: boolean,
        promotion: boolean,

    };


    const { loading, vehicleRecommendationError, success, error } = useSelector(
        (state: RootState) => ({
            success: state.auth.success,
            error: state.auth.error,
            vehicleRecommendationError: state.vehicleRecommendation.vehicleRecommendationError,
            loading: state.auth.loading
        })
    );



    const {
        register: registerLogin,
        handleSubmit: handleSubmitLogin,
        formState: { errors: loginErrors },
        reset: resetLogin,
    } = useForm<LoginFormValues>();


    const {
        register: registerRegister,
        handleSubmit: handleSubmitRegister,
        formState: { errors: registerErrors },
        reset: resetRegister,
        watch: watchRegister,
    } = useForm<RegisterFormValues>({
        defaultValues: {
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            password_confirmation: "",
            country_code: "+1",
            mobile: "",
            address: "",
            city: "",
            state: "",
            zip: "",
            terms_conditions: false,
            promotion: true,
        },
    });



    const onLoginSubmit: SubmitHandler<LoginFormValues> = (data) => {
        dispatch(loginUser(data.email, data.password));
    };


    const onRegisterSubmit: SubmitHandler<RegisterFormValues> = async (data) => {

        const success = await dispatch(registerUser(data));

        if (success) {

            dispatch(loginUser(data.email, data.password));
        }

    };


    const [isLogin, setIsLogin] = useState(true);



    useEffect(() => {
        if (success && isLogin) {
            showToast(success);
            resetLogin();
            resetRegister();
            dispatch(resetAuth());

            const backdrop = document.querySelector(".modal-backdrop");
            const loginModal = document.getElementById("login");

            if (loginModal) {
                loginModal.style.display = "none";
                loginModal.classList.remove("show", "modal-open");
            }

            if (backdrop) {
                backdrop.remove();
            }


            document.body.classList.remove("modal-open");
            document.body.style.overflow = "";
            document.body.style.paddingRight = "";


        } else if (success && !isLogin) {
            showToast("Login Successful");
            dispatch(resetAuth());
        }
        //  else if (success && !isLogin) {

        //     setIsLogin(true);
        //     resetRegister();
        //     dispatch(resetAuth());

        // }
        else if (error) {
            showToast(error);
            // reset();
            dispatch(resetAuth());
        }

    }, [success, error, isLogin]);



    const [toastMessage, setToastMessage] = useState('');
    const [toastClass, setToastClass] = useState('bg-success text-white');

    const showToast = (message: any) => {
        setToastClass(error ? 'bg-danger text-white' : 'bg-success text-white');
        setToastMessage(message);
    };


    const handleCloseToast = () => {
        setToastMessage('');
    };

    useEffect(() => {
        if (toastMessage) {
            if (toastClass === 'bg-danger text-white') {
                toast.error(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
            } else {
                toast.success(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
            }

        }
    }, [toastMessage, toastClass]);
    return (
        <>
            {/* {toastMessage && (
                <>
                    {toastClass === 'bg-danger text-white'
                        ? toast.error(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
                        : toast.success(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })}
                    <ToastContainer autoClose={3000} />
                </>
            )} */}

            <ToastContainer autoClose={3000} />
            <div
                className="modal new-modal fade"
                id="login"
                data-keyboard="false"
                data-backdrop="static"
            >
                <div className="modal-dialog modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            {isLogin ?
                                <h4 className="modal-title">Login</h4>
                                :
                                <h1 className="text-center" >Sign Up</h1>
                            }

                            <button
                                type="button"
                                className="close-btn"
                                data-bs-dismiss="modal"
                            >
                                <span>×</span>
                            </button>
                        </div>
                        <div className="modal-body">

                            {isLogin ?

                                <form onSubmit={handleSubmitLogin(onLoginSubmit)}>

                                    <div className="input-block">
                                        <label className="form-label">Email <span className="text-danger">*</span></label>
                                        <input type="email"   {...registerLogin("email", { required: "Email is required" })}
                                            className={`form-control mb-0 py-2 ${loginErrors.email ? "is-invalid" : ""}`}
                                        />
                                    </div>

                                    <div className="input-block">
                                        <label className="form-label">Password <span className="text-danger">*</span></label>
                                        <div className="pass-group">
                                            <input type={isToggle ? "text" : "password"}
                                                className={`form-control pass-input mb-0 py-2 ${loginErrors.email ? "is-invalid" : ""}`}
                                                {...registerLogin("password", { required: "Password is required" })} />
                                            <span onClick={() => setIsToggle(!isToggle)} className={`fas toggle-password ${isToggle ? "fa-eye" : "fa-eye-slash"}`} />
                                        </div>
                                    </div>


                                    <p className="text-danger my-2">{

                                        !vehicleRecommendationError?.includes("Unauthenticated") &&
                                            !vehicleRecommendationError?.includes("Unauthorized")
                                            ? vehicleRecommendationError
                                            : ""
                                    }</p>

                                    <button type="submit"
                                        disabled={vehicleRecommendationError === "Token has expired." || vehicleRecommendationError === "The selected token is invalid."}
                                        className="btn btn-primary py-1 w-100 btn-size mt-1">
                                        Sign In
                                    </button>



                                    <div className="text-center dont-have mt-3">
                                        <a href="#" onClick={() => setIsLogin(!isLogin)}
                                        >Register</a>
                                    </div>

                                </form>



                                :



                                <form onSubmit={handleSubmitRegister(onRegisterSubmit)}>

                                    <div className="d-flex gap-2">
                                        {/* Name */}
                                        <div className="input-block mb-0 flex-fill">
                                            <label className="form-label">First name  <span className="text-danger">*</span></label>
                                            <input type="text" className={`form-control ${registerErrors.first_name ? "is-invalid" : ""}`} {...registerRegister("first_name", { required: "First Name is required" })} />
                                            {/* {errors.first_name && <p className="text-danger">{errors.first_name.message}</p>} */}
                                        </div>

                                        <div className="input-block mb-0 flex-fill">
                                            <label className="form-label">Last name  </label>
                                            <input type="text" className={`form-control ${registerErrors.last_name ? "is-invalid" : ""}`} {...registerRegister("last_name")} />
                                            {/* {errors.last_name && <p className="text-danger">{errors.last_name.message}</p>} */}
                                        </div>
                                    </div>

                                    <p className="fs-13">Enter your name as it appears on your driver’s license</p>
                                    <div className="d-flex gap-2">
                                        {/* Email */}
                                        <div className="input-block mb-0 flex-fill">
                                            <label className="form-label">Email <span className="text-danger">*</span></label>
                                            <input type="email" className={`form-control ${registerErrors.email ? "is-invalid" : ""}`} {...registerRegister("email", { required: "Email is required" })} />
                                            {/* {errors.email && <p className="text-danger">{errors.email.message}</p>} */}
                                        </div>
                                        <div className="input-block mb-0 flex-fill">
                                            <label className="form-label">Mobile <span className="text-danger">*</span></label>
                                            <div className="d-flex">
                                                <input type="number" className={`form-control mb-0 ${registerErrors.mobile ? "is-invalid" : ""}`}   {...registerRegister("mobile", { required: "Mobile number is required" })} />
                                            </div>

                                        </div>
                                    </div>

                                    <div className="d-flex gap-2">
                                        {/* Password */}
                                        <div className="input-block mb-0 flex-fill">
                                            <label className="form-label">Password <span className="text-danger">*</span></label>
                                            <div className="pass-group">
                                                <input type={isToggle ? "text" : "password"} className={`form-control pass-input ${registerErrors.password ? "is-invalid" : ""}`}
                                                    {...registerRegister("password", {
                                                        required: "Password is required",
                                                        minLength: {
                                                            value: 6,
                                                            message: "Minimum 6 characters required",
                                                        },
                                                    })} />
                                                <span onClick={() => setIsToggle(!isToggle)} className={`fas toggle-password ${isToggle ? "fa-eye" : "fa-eye-slash"}`} />
                                            </div>
                                        </div>

                                        <div className="input-block  mb-0 flex-fill">
                                            <label className="form-label">Confirm Password <span className="text-danger">*</span></label>
                                            <div className="pass-group">
                                                <input type={isToggle ? "text" : "password"} className={`form-control pass-input ${registerErrors.password_confirmation ? "is-invalid" : ""}`}
                                                    {...registerRegister("password_confirmation", {
                                                        required: "Confirm Password is required",
                                                        minLength: {
                                                            value: 6,
                                                            message: "Minimum 6 characters required",
                                                        },
                                                        validate: (value) => value === watchRegister("password") || "Passwords do not match",
                                                    })}
                                                />
                                                <span onClick={() => setIsToggle(!isToggle)} className={`fas toggle-password ${isToggle ? "fa-eye" : "fa-eye-slash"}`} />
                                            </div>
                                        </div>
                                    </div>


                                    {<p className=""> <span className="text-danger">*</span>{" Password should be miminmu 6 character"}</p>}

                                    {/* Country Code + Mobile Number */}
                                    {/* <div className="col-md-12 py-2">
                                        <div className="input-block m-0">
                                            <label className="custom_check d-inline-flex location-check m-0">
                                                <span data-bs-toggle="modal" className="fs-13">
                                                    I agree to the terms of <u>service</u> and <u>privacy policy</u>. <span className="ms-1 text-danger"> *</span>
                                                </span>

                                                <input type="checkbox"   {...registerRegister("terms_conditions", { required: "Terms conditions is required" })}
                                                    checked={watchRegister("terms_conditions")} className={`checkmark form-control   ${registerErrors?.terms_conditions ? "is-invalid" : ""}`} />
                                                <span style={{ padding: 5 }} className={`checkmark form-control   ${registerErrors?.terms_conditions ? "is-invalid" : ""}`} />
                                            </label>
                                        </div>
                                    </div> */}

                                    {/* <div className="col-md-12 py-2">
                                        <div className="input-block m-0">
                                            <label className="custom_check d-inline-flex location-check m-0">
                                                <span className="fs-13"> Send me promotions and announcements via email</span>
                                                <input type="checkbox" {...registerRegister("promotion")} checked={watchRegister("promotion")} className={`checkmark form-control   ${registerErrors?.promotion ? "is-invalid" : ""}`} />
                                                <span style={{ padding: 5 }} className={`checkmark form-control   ${registerErrors?.promotion ? "is-invalid" : ""}`} />
                                            </label>
                                        </div>
                                    </div> */}

                                    {/* Submit Button */}
                                    {loading ?

                                        <div className="d-flex justify-content-center align-items-center">
                                            <Lottie animationData={Loader} loop={true} style={{ width: 100, height: 100 }} />
                                        </div>
                                        :
                                        <button type="submit" disabled={loading} className="btn btn-primary w-100 btn-size mt-1 py-2">{"Sign Up"}</button>}



                                    <div className="text-center dont-have mt-3">
                                        Already have an Account? <a href="#" onClick={() => setIsLogin(!isLogin)}   >Sign In</a>
                                    </div>

                                </form>}

                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Card Modal */}
        </>
    );
};

export default LoginModal;




